import CompilerRoutes from "./routes/CompilerRoutes";

function App() {
  return <CompilerRoutes />;
}

export default App;
